import { render } from "./VerifyOtp.vue?vue&type=template&id=c49807f6&scoped=true"
import script from "./VerifyOtp.vue?vue&type=script&lang=js"
export * from "./VerifyOtp.vue?vue&type=script&lang=js"

import "./VerifyOtp.vue?vue&type=style&index=0&id=c49807f6&scoped=true&lang=css"
import "./VerifyOtp.vue?vue&type=style&index=1&id=c49807f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c49807f6"]])

export default __exports__